import {
  Box,
  CircularProgress,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import http from "../../../../utils/http";
import { errorToastMessage } from "../../../../utils/toast";
import { CommonDrawerStyle, DrawerHeader } from "../../../Common/styles/drawer";

const TextStyle: SxProps = {
  fontWeight: "regular",
  typography: "body1",
  color: "text.secondary",
};

const SubTextStyle: SxProps = {
  fontWeight: "regular",
  typography: "subtitle1",
  color: "text.primary",
  textTransform: "capitalize",
};

type Props = {
  closeDrawer: () => void;
  groupId: string;
};

const ViewCohortDrawer: React.FC<Props> = ({ closeDrawer, groupId }) => {
  const { id: studyId } = useParams();
  const [data, setData] = useState<any>(null);
  console.log("data:", data);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let url = `/study/${studyId}/participant-groups/${groupId}`;
        const res: AxiosResponse = await http.get(url);
        const data = res.data?.data;
        const newData = data
          ? {
              groupId: data?.id,
              name: data?.name || "-",
              participants: data?.participantGroupMembers?.map(
                (member: any) => ({
                  id: member?.participant?.id,
                  subjectId: member?.participant?.subjectId,
                  //   name: member?.participant?.firstName
                  //     ? member?.participant?.lastName
                  //       ? `${member?.participant?.firstName} ${member?.participant?.lastName}`
                  //       : member?.participant?.firstName
                  //     : "",
                })
              ),
            }
          : null;
        setData(newData || {});
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [setLoading, studyId, groupId]);

  return (
    <Box sx={CommonDrawerStyle}>
      <DrawerHeader closeDrawer={closeDrawer} title={"View Cohort"} />

      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Stack gap={3}>
          <Stack gap={1}>
            <Stack gap={1}>
              <Typography sx={TextStyle}>Group Name</Typography>
              <Typography sx={SubTextStyle}>{data?.name}</Typography>
            </Stack>
          </Stack>
          <Stack gap={1}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                color: "text.primary",
              }}
            >
              Participant Details
            </Typography>

            <Stack gap={3}>
              {data?.participants.length > 0 &&
                data.participants.map((item: any) => (
                  <Stack
                    key={item?.id}
                    direction="row"
                    // columnGap={4}
                    rowGap={2}
                  >
                    {/* <Stack gap={1}>
                      <Typography sx={TextStyle}>Participant Name</Typography>
                      <Typography sx={{ ...SubTextStyle, mb: 1 }}>
                        {item?.name || "-"}
                      </Typography>
                    </Stack> */}
                    <Stack gap={1}>
                      <Typography sx={TextStyle}>Subject Id</Typography>
                      <Typography
                        sx={{ ...SubTextStyle, textTransform: "none" }}
                      >
                        {item?.subjectId || "-"}
                      </Typography>
                    </Stack>
                  </Stack>
                ))}
              {data?.participants.length === 0 && (
                <Typography sx={TextStyle}>No Participants</Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default ViewCohortDrawer;
